<template>
	<router-link :to="'/מתכונים/' + post.slug" tag="div" class="post">
		<div class="image" v-html="post.image"></div>

		<p class="tags">
			<span
				class="tag"
				v-for="(tag, tagIndex) in post.tags"
				:key="'tag_' + tag.term_id"
			>
				{{ tag.name }}{{ tagIndex < post.tags.length - 1 ? ", " : "" }}
			</span>
		</p>
		<h5 class="title">{{ post.title }}</h5>
		<p class="excerpt" v-html="post.excerpt"></p>

		<p class="cta"><u>קרא עוד</u> &larr;</p>
	</router-link>
</template>

<script>
	export default {
		data() {
			return {
				wpData: window.wpData,
				acf: { ...window.wpData.pageData.acf },
			};
		},
		props: {
			post: Object,
		},
		created() {},
		computed: {},
		methods: {},
		components: {},
	};
</script>

<style lang="sass" scoped>

	$grey1: #f7f7f7
	$grey2: #eaeaea
	$red: #ea4725
	$white: #ffffff
	$black: #000000
	$dark: #213519
	$green: #cbe5c0

	.post
		position: relative
		border-radius: 0.5rem
		border-top-left-radius: 0rem
		overflow: hidden
		width: calc((100% - 9rem) / 4)
		cursor: pointer
		transition: transform 200ms ease-out, border-color 200ms ease-out
		padding: 1rem
		border: 2px solid $grey2
		transform: translateZ(0)
		&:focus, &:hover
			transform: scale(1.05) translateZ(0)
			border-color: $dark

	.tags
		margin-bottom: 1rem
		white-space: nowrap
		overflow: hidden
		text-overflow: ellipsis
		font-weight: bold
		font-size: 0.85rem

	.title
		font-family: 'simpler'
		font-size: 1.35rem
		font-weight: bold
		margin-bottom: 0.5rem

	.excerpt
		margin-bottom: 1rem
		opacity: 0.8

	.cta
		font-weight: bold
		margin-bottom: 1rem

	.image ::v-deep img
		width: 100%
		height: auto
		border-radius: 0.5rem
		border-top-left-radius: 0
		margin-bottom: 0.5rem

	/* MOBILE */
	@media screen and (max-width: 800px)
		.mobile-only
			display: block
		.desktop-only
			display: none

		.post
			width: 100%
			text-align: right

		.inner-content
			padding: 1rem 1.85rem
			.title
				font-size: 1.35rem
				margin-top: 0
		.excerpt
			font-size: 0.85rem
		.cta
			font-size: 0.85rem
</style>
